import { useEffect } from "react";

/**
 * Inject structured data (JSON-LD) into <head> for SEO.
 * Pass a single object or an array of schema.org objects.
 */
export default function JsonLd({ data, id }) {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2, 8)}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(scriptId);
      if (node) node.remove();
    };
  }, [data, id]);
  return null;
}
